import React from 'react';

interface INullableFieldOverlayProps {
  onSetNull: () => void;
  children: React.ReactNode;
}

export const NullableFieldOverlay: React.FC<INullableFieldOverlayProps> = ({
  onSetNull,
  children
}) => {
  return (
    <div className="relative">
      {children}
      <button
        type="button"
        onClick={onSetNull}
        className="absolute right-2 top-[34px] rounded px-1.5 py-0.5 text-p-xs font-medium text-base-mutedForeground hover:text-base-foreground hover:bg-base-border transition-colors"
      >
        Set null
      </button>
    </div>
  );
};
